import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceList } from '../../../models';
import { NameAndPrice, PrivateLessonsDataTable } from '../../../models/types';
import { MoreInfoListComponent } from '../more-info-list/more-info-list.component';
import { MoreInfoTitleComponent } from '../more-info-title/more-info-title.component';
import { CompanyEnum } from '../../../models/company.model';
import { PricePipe } from '@lx/shared/ui/pipes';
import { TableModule } from 'primeng/table';

@Component({
  standalone: true,
  imports: [CommonModule, MoreInfoListComponent, MoreInfoTitleComponent, PricePipe, TableModule],
  selector: 'lx-price-lists-portal-positively-languages-more-info',
  templateUrl: './positively-languages-more-info.component.html',
  styleUrls: ['./positively-languages-more-info.component.scss'],
})
export class PositivelyLanguagesMoreInfoComponent implements OnInit {
  @Input() priceList!: PriceList;

  tuitionUpgradesAndAddOns: NameAndPrice[] = [];
  accommodationSupplements: NameAndPrice[] = [];
  seasonSupplements: NameAndPrice[] = [];

  privateLessonsDataSource: PrivateLessonsDataTable[] = [];
  privateLessonsTableLabels = [];

  KIL = CompanyEnum.KIL;

  ngOnInit(): void {
    this.tuitionUpgradesAndAddOns = this.priceList.addOns?.map(({ name, price }) => ({ name, price }));
    this.accommodationSupplements = this.priceList.accommodationSupplements?.map(({ name, price }) => ({ name, price }));
    this.seasonSupplements = this.priceList.seasonSupplements?.map(({ name, price }) => ({ name, price }));

    this.priceList?.privateLessons?.forEach((privateLesson) => {
      this.privateLessonsTableLabels.push(privateLesson.name);
      privateLesson.lessons?.forEach((lesson) => {
        const pricesForGroup = this.privateLessonsDataSource?.find(({ numberOfLessons }) => numberOfLessons === lesson.name);
        if (!pricesForGroup) {
          this.privateLessonsDataSource.push({ numberOfLessons: lesson.name, prices: [lesson.price] });
        } else {
          pricesForGroup.prices = [...pricesForGroup.prices, lesson.price];
        }
      });
    });
  }
}
